/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComment,
  faCommentDots,
  faShareSquare,
} from "@fortawesome/free-regular-svg-icons";
import { faMessage, faStar } from "@fortawesome/free-solid-svg-icons";
import { dateDiff } from "../../../../_helpers/dateFormatter";
import { Spinner } from "react-bootstrap";

export default function ({
  shortlistCandidates,
  setLastElement,
  onViewAssessmentClick,
  onPublicProfileClick,
  onShareAssessmentClick,
  nextPage,
  onNextPageClick,
  onClickUnShortlist,
  remark,
  shortlistIdLoading,
}) {
  return (
    <div className="container">
      <div className="job-listing">
        {shortlistCandidates &&
        Array.isArray(shortlistCandidates) &&
        shortlistCandidates.length ? (
          <div className="row">
            {Array.isArray(shortlistCandidates) &&
              shortlistCandidates.map((item, index) => (
                <div
                  className="col-lg-6  mb-4"
                  key={index}
                  ref={setLastElement}
                >
                  <div
                    className="job-box p-3 d-flex h-100 flex-column my-0 bg-white border position-relative rounded-lg"
                    style={{
                      boxShadow: "0px 1px 2px rgba(122, 134, 154, 0.25)",
                    }}
                  >
                    <div className="d-flex mb-3 align-items-start">
                      <img
                        src={
                          item?.short_listed_candidate_details &&
                          item.short_listed_candidate_details?.user_meta_info &&
                          item.short_listed_candidate_details.user_meta_info
                            ?.profile_image
                            ? item?.short_listed_candidate_details &&
                              item.short_listed_candidate_details
                                ?.user_meta_info &&
                              item.short_listed_candidate_details.user_meta_info
                                ?.profile_image
                            : "/assets/images/dummy.png"
                        }
                        alt="candidate"
                        className="mr-3 border-radius-10"
                        style={{
                          width: "70px",
                          height: "60px",
                          objectFit: "cover",
                        }}
                      />
                      <div className="job-info">
                        <h3
                          className="font-weight-bold mb-1 text-capitalize cursor-pointer text-primary"
                          onClick={(e) => onPublicProfileClick(item)}
                        >
                          {item?.short_listed_candidate_details &&
                            item.short_listed_candidate_details?.full_name}
                        </h3>
                        <p className="text-grey-4">
                          {item?.candidate_headline}
                        </p>
                      </div>
                      <div className="ml-auto">
                        <button
                          className="bg-transparent border-0"
                          onClick={() => onShareAssessmentClick(item)}
                          title="share"
                        >
                          <img
                            src="/assets/images/share-icon.svg"
                            alt="share"
                          />
                        </button>

                        {item?.candidate === shortlistIdLoading ? (
                          <Spinner
                            animation="border"
                            variant="primary"
                            size="sm"
                            className="ml-2"
                          />
                        ) : (
                          <button
                            className="bg-transparent border-0"
                            onClick={() =>
                              onClickUnShortlist(item?.candidate, item?.id)
                            }
                            title="UnShortlist"
                          >
                            <img
                              src="/assets/images/star-yellow.svg"
                              alt="star"
                            />
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="d-flex align-items-center fs-smallest mb-2 ">
                      <p className="skills-list mb-0 mr-5 text-capitalize">
                        <span className="font-weight-medium text-grey-4">
                          Answered Questions:{" "}
                        </span>
                        {item?.answered_ques_count}
                      </p>

                      <p className="skills-list mb-0 mr-2  text-capitalize">
                        <span className="font-weight-medium text-grey-4">
                          Total Questions:{" "}
                        </span>
                        {item?.total_questions}
                      </p>
                    </div>
                    {Array.isArray(
                      item?.short_listed_candidate_details &&
                        item.short_listed_candidate_details?.skills &&
                        item.short_listed_candidate_details.skills
                    ) &&
                    item?.short_listed_candidate_details &&
                    item.short_listed_candidate_details?.skills &&
                    item.short_listed_candidate_details.skills.length > 0 ? (
                      <div className="d-flex align-items-center flex-wrap fs-smallest mb-3">
                        <p className="mr-2 text-capitalize mb-0">
                          <span className="font-weight-medium">Skills: </span>

                          {Array.isArray(
                            item?.short_listed_candidate_details?.skills
                          ) &&
                            item?.short_listed_candidate_details?.skills.map(
                              (skill, index) => (
                                <span
                                  key={index}
                                  className="skill bg-grey px-2 rounded-sm mr-2 my-1 py-1 mb-2"
                                >
                                  {skill}
                                </span>
                              )
                            )}
                        </p>
                      </div>
                    ) : null}

                    {item?.remark && item?.remark?.remark ? (
                      <p className="skills-list mb-0 mr-2  text-capitalize  fs-smallest  mb-3">
                        <FontAwesomeIcon
                          icon={faCommentDots}
                          className="mr-2 d-inline"
                        />
                        {item?.remark && item?.remark?.remark}
                      </p>
                    ) : null}

                    <div className="job-bottom d-flex align-items-center justify-content-between mt-auto ">
                      <span className="text-muted fs-smallest mr-2">
                        Shortlisted{" "}
                        {item?.created && dateDiff(item?.created, new Date())}{" "}
                        ago
                      </span>

                      <div className="d-flex ml-auto align-items-center fs-smallest text-uppercase">
                        <span
                          className={`d-inline-block ${
                            item?.total_questions === item?.answered_ques_count
                              ? "label-green"
                              : item?.is_accepted == true
                              ? "label-voilet"
                              : "label-yellow"
                          } rounded position px-2 ml-2`}
                        >
                          {item?.total_questions === item?.answered_ques_count
                            ? "completed"
                            : item?.is_accepted
                            ? "Accepted"
                            : "Pending"}
                        </span>

                        <button
                          className="text-primary border-0 bg-transparent ml-2 font-weight-semi"
                          onClick={() =>
                            onViewAssessmentClick(
                              item?.short_listed_candidate_details &&
                                item?.short_listed_candidate_details?.id
                            )
                          }
                        >
                          View Assessment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <p className="fs-24 bg-white text-danger font-weight-medium text-center rounded-lg p-4">
            <img
              src="/assets/images/no-shortlisted.png"
              alt="no-suggested candidates"
            />
          </p>
        )}
      </div>

      {nextPage &&
        shortlistCandidates &&
        Array.isArray(shortlistCandidates) &&
        shortlistCandidates.length && (
          <button
            className="btn btn-secondary py-2 "
            onClick={() => onNextPageClick()}
          >
            Load More
          </button>
        )}
    </div>
  );
}
